<div class="input-bar">
  <textarea
    class="input-field"
    [value]="text()"
    (keydown)="onKeydown($event)"
    (input)="onTextInput($event)"
    placeholder="Message..."
    rows="1"></textarea>

  <button
    class="send-btn"
    [disabled]="!canSend()"
    (click)="send()"
    aria-label="Send">
    Send
  </button>
</div>
